<template>
  <b-modal :id="modalId" title="Create Organization" hide-footer size="lg" no-close-on-backdrop>
    <organization-form buttonLabel="Create"
      :isSaving="isCreating"
      @saveOrganization="createOrganization" />
  </b-modal>
</template>

<script>
import OrganizationForm from '../Forms/OrganizationForm.vue';
import config from '../../constants/config';

export default {
  name: 'CreateOrganizationModal',
  components: {
    OrganizationForm
  },
  props: {
    organization: Object
  },
  data() {
    return {
      isCreating: false,
    };
  },
  methods: {
    async createOrganization(organization) {
      this.isCreating = true;
      const success = await this.$store.dispatch('organization/createOrganization', organization);

      if (success) {
        this.$emit('hasUpdate');
        this.$bvModal.hide(this.modalId);
      }
      this.isCreating = false;
    }
  },
  computed: {
    modalId() {
      return config.CREATE_ORG_MODAL_ID;
    }
  }
};
</script>
